<template>
  <div class="levelFourPage">
    <!-- 头部 -->
    <swipeTop :top_img="top_img" :ZHtitle="ZHtitle" :ENtitle="ENtitle" />
    <!-- 搜索框 -->
    <!-- <seachVue /> -->
    <!-- 分类导航栏 -->
    <classifyList :toptype="toptype" :checkindex="checkindex" />
    <!-- 内容 -->
    <div class="content">
      <div class="listBox">
        <div
          :style="{ backgroundImage: 'url(' + item.pic + ')' }"
          v-for="(item, index) in itemList"
          @click="toChilder(item)"
          :key="index"
          class="listItem"
        >
          <span>{{ item.menuName }}</span>
        </div>
      </div>
      <!-- <div class="backColor">
        <div
          @click="toChilder(item)"
          v-for="(item, index) in itemList"
          :key="index"
          class="item"
        >
          <van-image width="30" height="30" :src="item.pic"></van-image>
          <span>{{ item.menuName }}</span>
        </div>
      </div> -->
      <!-- <listVue :projuctList="itemList"></listVue> -->
    </div>
  </div>
</template>

<script>
import swipeTop from "@/components/swipeTop.vue";
import seachVue from "@/components/seachVue.vue";
import classifyList from "@/components/classifyList.vue";
import { genMenuInfo } from "@/api/path";
import listVue from "../../components/listVue.vue";
export default {
  components: {
    swipeTop,
    seachVue,
    classifyList,
    listVue,
  },
  data() {
    return {
      menuId: this.$route.query.menuId,
      checkindex: Number(this.$route.query.checkindex),
      top_img: "", // 头部背景图片
      ZHtitle: "", // 中文标题
      ENtitle: "", //  英文标题
      itemList: [],
      toptype: [], // 导航标签数据
    };
  },
  created() {
    this.getAllMenu();
  },
  methods: {
    // 获取本页面基本信息
    getAllMenu() {
      genMenuInfo(this.menuId)
        .then((res) => {
          this.ZHtitle = res.data.menuName; // 获取中文标题
          this.top_img = res.data.background; // 获取头部背景图片
          this.ENtitle = res.data.menuEnglish; // 英文标题
          this.itemList = res.data.subMenuList;
          this.toptype = res.data.classificationMessageAlways; // 获取导航标签数据
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 五级页面
    toChilder(item) {
      this.$router.push({
        path: "/levelFivepage",
        query: { menuId: item.menuId, checkindex: this.checkindex },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.levelFourPage {
  height: 100vh;
  .content {
    height: 61%;
    background-color: #8e0a10;
    overflow: scroll;
    display: flex;
    flex-direction: column;
    align-items: center;
    .listBox {
      width: 92%;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      .listItem {
        width: 100%;
        height: 10vh;
        box-shadow: 1px -1px 4px 0 #803e3e;
        border-radius: 10px;
        margin-bottom: 30px;
        background-color: aqua;
        background-size: cover;
        span {
          width: 60%;
          display: inline-block;
          margin: 10px 0 0 30px;
          color: white;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
